<script setup lang="ts">
import { computed, ref, toRef } from 'vue'
import FeedColumn from './theater.vue'
import type { IRefVideoItem } from '@/components/feed-player'
import type { ICreationFeedItem } from '../../types'
import { toPlayerFeedItem } from '../../data-adapter'

const props = defineProps<{
  items: ICreationFeedItem[]
  windowSize?: number
  playbackEnabled?: boolean
  navigationEnabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'indexChange', index: number): void
  (e: 'remix', creationId: number): void
}>()

const items = toRef(props, 'items')

const playerItems = computed<IRefVideoItem[]>(() => items.value.map(item => toPlayerFeedItem(item)))

type FeedColumnExpose = {
  jumpToIndex: (index: number) => void
  currentIndex: number
  resetNavigationState: () => void
}

const feedRef = ref<FeedColumnExpose | null>(null)

defineExpose({
  jumpToIndex: (index: number) => feedRef.value?.jumpToIndex(index),
  currentIndex: computed(() => feedRef.value?.currentIndex ?? 0),
  resetNavigationState: () => feedRef.value?.resetNavigationState(),
})
</script>

<template>
  <FeedColumn
    ref="feedRef"
    :items="playerItems"
    :window-size="windowSize"
    preset="creation"
    :is-clear-mode="true"
    :playback-enabled="playbackEnabled"
    :navigation-enabled="navigationEnabled"
    @index-change="emit('indexChange', $event)"
    @primary-action="emit('remix', $event)"
  >
  </FeedColumn>
</template>
